import { gql } from 'apollo-angular';

export const GET_PRODUCTS_BY_PRODUCT_ID = gql`
  query GetChildProductsByRfpAndBaseProduct(
    $rfpId: Long!
    $baseProductId: Long!
  ) {
    rfpProductsByBaseProductId(
      input: { rfpId: $rfpId, baseProductId: $baseProductId }
    ) {
      id
      catalogNumber
      description
      packageString
      status
      brandName
      aptitudeCategory {
        id
        name
      }
      categories {
        id
        name
        parents {
          id
          name
        }
      }
      productSource
      scopeStatus
      seller {
        id
        name
      }
      sysSeller {
        id
        name
      }

      spend {
        actualSpend
        continuedSpend
        annualizedSpend
        lastPricePaid
      }
      manufacturer {
        id
        name
      }
      distributor {
        id
        name
      }
      baseProductId
      supplierType
      distributor {
        id
        name
      }
    }
  }
`;
